import PropTypes from 'prop-types';
import { Steps } from 'primereact/steps';
import { Icon } from '@iconify/react';
import { StepperOrientation } from './enum/StepperEnum';
import './Stepper.scss';

export const Stepper = ({
  items = [],
  activeIndex = 0,
  onStepChange,
  orientation = StepperOrientation.HORIZONTAL,
  className = '',
  readOnly = false,
  completedSteps = [],
  labelPosition = 'right', // 'right' | 'bottom'
}) => {

  const handleStepClick = (index) => {
    if (!readOnly && onStepChange) {
      onStepChange(index);
    }
  };

  // Enhanced items with custom template for Iconify icons
  const stepItems = items.map((item, index) => {
    const isCompleted = completedSteps.includes(index);

    return {
      ...item,
      label: item.label,
      template: (stepItem) => {
        return (
          <div className="p-menuitem-link" onClick={() => handleStepClick(index)}>
            <span className="p-steps-number">
              {isCompleted ? (
                <Icon icon="solar:check-circle-bold" width="20" height="20" />
              ) : item.icon ? (
                <Icon icon={item.icon} width="20" height="20" />
              ) : (
                <span>{index + 1}</span>  // 👈 fallback to number
              )}
            </span>
            <span className="p-steps-title">{stepItem.label}</span>
          </div>
        );
      },
      className: isCompleted ? 'step-completed' : '',
    };
  });

  return (
    <div
      className={`stepper-wrapper ${orientation} label-${labelPosition} ${readOnly ? 'read-only' : ''} ${className}`}
      data-active-index={activeIndex}
    >
      <Steps
        model={stepItems}
        activeIndex={activeIndex}
        readOnly={readOnly}
        className="custom-stepper"
      />
    </div>
  );
};

Stepper.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string, // Iconify icon name (e.g., 'solar:user-bold')
      command: PropTypes.func,
    })
  ),
  activeIndex: PropTypes.number,
  onStepChange: PropTypes.func,
  orientation: PropTypes.oneOf(Object.values(StepperOrientation)),
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  completedSteps: PropTypes.arrayOf(PropTypes.number),
  labelPosition: PropTypes.oneOf(['right', 'bottom']),
};

Stepper.defaultProps = {
  items: [],
  activeIndex: 0,
  orientation: StepperOrientation.HORIZONTAL,
  readOnly: false,
  completedSteps: [],
  labelPosition: 'right',
};